import { Patientlable } from "../models/patientlable";
import { API_PREFIX } from "./constant";
import { Request } from "./request";

export interface PatientTableParams {
  current?: number;
  tenantId?: string;
  id?: number;
  backgroundColor?: string;
  fontColor?: string;
  name?: string;
  headName?: string;
  size?: number;
  state?: number;
}

export function getLableList(params: PatientTableParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/label/list`,
    method: "GET",
    params,
  };
}

export function getPatientLabelList(patientId: string): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/patientlabel/list`,
    method: "GET",
    params: {
      current: 1,
      size: 1000,
      patientId,
    },
  };
}

export function getLableDetail(labelId: string): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/label/detail`,
    method: "GET",
    params: {
      labelId,
    },
  };
}

export function getLableSave(body: Patientlable): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/label/save`,
    method: "POST",
    body,
  };
}

export interface LabelPatientParams {
  patientId?: string;
  labelId?: string;
  set: boolean;
}

export function labelPatient(params: LabelPatientParams): Request {
  return params.set
    ? {
        url: `${API_PREFIX}/blade-outpatient/patientlabel/submit`,
        method: "POST",
        body: {
          ...params,
          set: undefined,
        },
      }
    : {
        url: `${API_PREFIX}/blade-outpatient/patientlabel/remove`,
        method: "POST",
        params: {
          ids: params.labelId,
        },
      };
}
